import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  StyledCategoryTag,
  StyledCategoryTagText,
  StyledCurrencyAbbreviation,
  StyledCurrencyCircle,
  StyledSymbolContainer,
  StyledSymbolDescription,
  StyledSymbolHeading,
  StyledSymbolName,
} from '../styled';
import { AssetSymbolProps } from '../types';

/**
 * Helper function to get translation key for category
 */
const getCategoryTranslationKey = (category: string): string => {
  const keyMap: Record<string, string> = {
    Futures: 'pinnedAssetOverview.categories.futures',
    Forex: 'pinnedAssetOverview.categories.forex',
    Crypto: 'pinnedAssetOverview.categories.crypto',
    Stocks: 'pinnedAssetOverview.categories.stocks',
    Indices: 'pinnedAssetOverview.categories.indices',
  };
  return keyMap[category] || category;
};

/**
 * Asset Symbol Component
 * Displays currency circle, symbol name, category tag, and description
 */
export const AssetSymbol: FC<AssetSymbolProps> = ({ symbol }) => {
  const { t } = useTranslation('communityStats');

  return (
    <StyledSymbolContainer>
      <StyledCurrencyCircle>
        <StyledCurrencyAbbreviation>
          {symbol.abbreviation}
        </StyledCurrencyAbbreviation>
      </StyledCurrencyCircle>

      <StyledSymbolHeading>
        <StyledSymbolName>{symbol.symbol}</StyledSymbolName>
        <StyledCategoryTag>
          <StyledCategoryTagText>
            {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
            {t(getCategoryTranslationKey(symbol.category) as any)}
          </StyledCategoryTagText>
        </StyledCategoryTag>
      </StyledSymbolHeading>

      <StyledSymbolDescription>{symbol.name}</StyledSymbolDescription>
    </StyledSymbolContainer>
  );
};
